import React from 'react';
import { completionDurationMinutes } from 'components/tasks/TaskPane/timeLog';
import { Task, TimeEntry } from 'services/tasks/types';
import AddTimeEntryModal from './AddTimeEntryModal';

interface CompletionTimeEntryModalProps {
  onHide: () => void;
  onSave: (patch: { timeEntries: TimeEntry[] }) => void;
  task: Task;
}

const CompletionTimeEntryModal = ({
  onHide,
  onSave,
  task,
}: CompletionTimeEntryModalProps) => (
  <AddTimeEntryModal
    initialDurationMinutes={completionDurationMinutes(task)}
    initialTimeLeft="0"
    onHide={onHide}
    onSave={onSave}
    show
    task={task}
  />
);

export default CompletionTimeEntryModal;
